/**
 * Converts a base64 encoded string to a Blob object
 * @param base64 - The base64 encoded string (without data URI prefix)
 * @param contentType - The MIME type of the content (default: 'application/pdf')
 * @returns Blob object that can be used with URL.createObjectURL()
 */
export function base64ToBlob(base64: string, contentType = 'application/pdf'): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
}
